import $ from 'jquery'
import get from 'lodash/get'
import throttle from 'lodash/throttle'

const $window = $(window)
const $parallax = $('[data-parallax]')
const $header = $('[data-header]')
const $backToTop = $('[data-back-to-top]')
const threadhold = 140

let opacityMult = 1
let maxHeight = 0
let parallaxAmount = 2

let allowParallax = false
let allowHeader = false

export function init() {
  if ($parallax.length) {
    allowParallax = true
    maxHeight = $parallax.height()
    opacityMult = get($parallax.data('parallax'), 'opacityMult', 1)
    parallaxAmount = get($parallax.data('parallax'), 'amount', 2)
    $window.resize(() => (maxHeight = $parallax.height()))
  }

  if ($header.length && $header.hasClass('header-transparent')) {
    allowHeader = true
  }

  $backToTop.on('click', function () {
    $('html, body').animate({ scrollTop: 0 }, 1000, 'swing')
  })

  $window.scroll(throttle(parallax, 1000 / 60))
}

function parallax() {
  const scrollTop = $window.scrollTop()
  if (allowParallax) {
    if (scrollTop < maxHeight)
      $parallax.css({
        opacity: ((maxHeight - scrollTop) / maxHeight) * opacityMult,
        transform: 'translate3d(0px,' + scrollTop / parallaxAmount + 'px, 0px)',
      })
  }
  if (allowHeader) {
    if (scrollTop > threadhold) {
      $header.removeClass('header-transparent')
    } else {
      $header.addClass('header-transparent')
    }
  }
  if (scrollTop > 1000) {
    if (!$backToTop.hasClass('active')) $backToTop.addClass('active')
  } else {
    if ($backToTop.hasClass('active')) $backToTop.removeClass('active')
  }
}
